import _ from "lodash";
import QueryMessages from "graphql/queries/QueryMessages";
import { messageConstants } from "utils/constants/message-constants";
import HelperCollection from "utils/helper-collection";
import MutationMessage from "graphql/mutations/MutationMessage";
import { constantsActive } from "utils/constants/constants";
import GraphqlGroupedBuilder from 'utils/request/graphql/groupedBuilder'

export default class FetchMessage {
	
	static fetchAll( { callbackSuccess = null, callbackError = null, callbackStart = null, pagination = {}, kind = [], variables = {} } = {} ) {
		GraphqlGroupedBuilder.addQuery( 'messages', QueryMessages, {
			variables: {
				...pagination,
				kind: kind,
				...variables
			},
			resultPath: [ 'messages' ],
			callbackStart,
			callbackError,
			callbackSuccess: result => {
				const messagesCombined = _.map( result, message => {
					return (
						{
							...message,
							kind: messageConstants.MESSAGE
						}
					);
				});

				// Filter the empty fields
				const messages = HelperCollection.filterWithoutGuid(
					_.orderBy( messagesCombined, [ 'created_at' ], [ 'desc' ] )
				);
				
				if( _.isFunction( callbackSuccess ) ) {
					callbackSuccess({
						messages: messages
					});
				}
			}
		})
	}

	static fetchOne = ( guid, { callbackSuccess = null, callbackError = null, callbackStart = null } = {} ) => {
		GraphqlGroupedBuilder.addQuery( 'message', MutationMessage, {
			variables: {
				guid: guid,
				is_read: constantsActive.YES
			},
			resultPath: [ 'message' ],
			callbackStart,
			callbackError,
			callbackSuccess: result => {
				if( callbackSuccess !== null && _.isFunction( callbackSuccess ) ) {
					callbackSuccess({
						message: result
					});
				}
			}
		})
	};
}
